import axios, { AxiosResponse } from 'axios';

import { IEmisniUdaje } from 'services/akcionar/emise/novyIsinSend';
import { ETypPrevodu } from 'services/specialniSluzby/uePozadavky';
import { IZalozeniPostId } from 'services/specialniSluzby/ueZalozeni';

import { ETypZpusobPredani, EtypPrilohy } from 'enums/dokumentyEnums';
import { EDruhCp } from 'enums/isin/udaje/druhCp';
import { EFrekvenceVyplaty } from 'enums/isin/udaje/frekvenceVyplaty';

import { ERozsahPPN } from './navyseni';

export const dokumentDodatekBankUcetPut = (
    id: number | string,
    data: {
        predcisli?: string;
        cislouctu: string;
        banka: string;
        iban?: string;
    }
) => {
    return axios({
        method: 'PUT',
        url: `/DOK/${id}/bankucet`,
        data: data
    }).then((resp: AxiosResponse<IDodatekPrilohy>) => resp.data);
};

export interface IDodatekIsinData extends IEmisniUdaje {
    kapital: string;
    mena: string;
    splaceno: string;
}

export interface IDodatekIsins {
    isin: string;
    data: IDodatekIsinData;
    druhcp: EDruhCp;
    typprevodu: ETypPrevodu;
    zpuspredvp?: ETypZpusobPredani;
    zpuspredfp?: ETypZpusobPredani;
    admin: boolean;
    idisin: number;
    cfi: string;
    bic: string;
    nazev: string;
    vicupisovatelu?: boolean;
    denupllhu: string;
    denupldodatlhu: string;
    denuplmaju: string;
    datregistr: string;
    datzaknih: string;
    premena: boolean;
    splaceno: string;
    kapital: string;
    mena: string;
    potvrzeno: boolean;
    zmenregi?: boolean;
    zmenosoba: string;
    pocetcpvn?: number;
}

export interface IDodatekIsinsPut {
    potvrzeno: boolean;
    datregistr: string;
    datzaknih: string;
    premena: boolean;
    denupllhu: string;
    denupldodatlhu: string;
    denuplmaju: string;
    typprevodu: ETypPrevodu;
    zpuspredvp?: ETypZpusobPredani;
    zpuspredfp?: ETypZpusobPredani;
    vicupisovatelu?: boolean;
    admin?: boolean;
}

export const dokumentDodatekIsinGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/detisin`
    }).then((resp: AxiosResponse<IDodatekIsins>) => resp.data);
};

export const dokumentDodatekIsinPut = (id: number | string, data: IDodatekIsinsPut) => {
    return axios({
        method: 'PUT',
        url: `/DOKdodatek/${id}/detisin`,
        data: data
    });
};

export interface IDodatekPriloha {
    idpriloha: number;
    orignazev: string;
    typprilohy: EtypPrilohy;
    tempnazev: string;
    nazev: string;
}
export interface IDodatekPrilohy {
    prilohy: IDodatekPriloha[];
}

export const dokumentDodatekPrilohyGet = (id: number | string, dokJiny?: boolean) => {
    return axios({
        method: 'GET',
        url: `/${dokJiny ? 'DOKjiny' : 'DOK'}/${id}/prilohy`
    }).then((resp: AxiosResponse<IDodatekPrilohy>) => resp.data);
};

export const dokumentDodatekPrilohyPost = (
    id: number | string,
    data: {
        tempnazev: string;
        typprilohy: EtypPrilohy;
        orignazev: string;
    },
    dokJiny?: boolean
) => {
    return axios({
        method: 'POST',
        url: `/${dokJiny ? 'DOKjiny' : 'DOK'}/${id}/prilohy/soubor`,
        data: data
    }).then((resp: AxiosResponse<IDodatekPrilohy>) => resp.data);
};

export const dokumentDodatekPrilohyDelete = (id: number | string, idSoubor: number | string, dokJiny?: boolean) => {
    return axios({
        method: 'DELETE',
        url: `/${dokJiny ? 'DOKjiny' : 'DOK'}/${id}/prilohy/${idSoubor}`
    }).then((resp: AxiosResponse<IDodatekPrilohy>) => resp.data);
};
export const dokumentDodatekPrilohyDownload = (id: number | string, idSoubor: number | string, dokJiny?: boolean) => {
    return axios({
        method: 'GET',
        url: `/${dokJiny ? 'DOKjiny' : 'DOK'}/${id}/prilohy/${idSoubor}`
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export interface IDodatekAkcie {
    nahrazsezakc: boolean;
    zamestakcppn: boolean;
    rozsahppn: ERozsahPPN;
}
export interface IDodatekDluhDatum {
    datrozhkup: string;
    datexkup: string;
}
export interface IDodatekDluh {
    pocdnikup: number;
    pocdnijist: number;
    typdatjist: 'KUPON' | 'JINE';
    datemise: string;
    datjist: string;
    datexjist: string;
    dluhdatumy: IDodatekDluhDatum[];
    pocetcp: number;
    isinjistiny: string;
    blokace: boolean;
}
export interface IDodatekNkoliv {
    poczaknih: number;
    poczaknihupis: number;
    maxobjem: number;
    celkhodnota: number;
    navakcie: number;
    mena: string;
    datkurzu: string;
}
export interface IDodatekInvcert {
    poczaknihupis: number;
}

export interface IDodatekSluzbaTypes {
    AKCIE: IDodatekAkcie;
    DLUHOPIS: IDodatekDluh;
    NASTROJKOLINV: IDodatekNkoliv;
    PODILLIST: IDodatekNkoliv;
    INVCERT: IDodatekInvcert;
}

export enum EDruhCpSluzba {
    AKCIE = 'akcie',
    DLUHOPIS = 'dluh',
    NASTROJKOLINV = 'nkolinv',
    INVCERT = 'invcert',
    PODILLIST = 'podil'
}

export const dokumentDodatekDruhCpGet = <IdruhCp extends keyof IDodatekSluzbaTypes>(
    id: number | string,
    druhcp: IdruhCp
) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/${EDruhCpSluzba[druhcp]}`
    }).then((resp: AxiosResponse<IDodatekSluzbaTypes[IdruhCp]>) => resp.data);
};

export const dokumentDodatekDruhCpPut = <IdruhCp extends keyof IDodatekSluzbaTypes>(
    id: number | string,
    druhcp: IdruhCp,
    data: IDodatekSluzbaTypes[IdruhCp]
) => {
    return axios({
        method: 'PUT',
        url: `/DOKdodatek/${id}/${EDruhCpSluzba[druhcp]}`,
        data: data
    });
};

export interface IDodatekDFPUcet {
    iducet: number;
    cdac: string;
    rcma: string;
    idma: string;
    qtet: number;
    idmb: string;
    pjma: string;
    jmma: string;
    ttma: string;
    rliv: string;
    ppn: boolean;
}
export interface IDodatekDFP {
    ucty: IDodatekDFPUcet[];
    celkemcp: number;
}

export interface IDodatekDFPUcetPut {
    cdac: string;
    rcma: string;
    idma: string;
    qtet: number;
    idmb: string;
    pjma: string;
    jmma: string;
    ttma: string;
}

export const dokumentUcetDfpGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOK/${id}/ucet`
    }).then((resp: AxiosResponse<IDodatekDFP>) => resp.data);
};

export const dokumentUcetDfpDeleteAll = (id: number | string) => {
    return axios({
        method: 'DELETE',
        url: `/DOK/${id}/ucet`
    });
};

export const dokumentUcetDfpDelete = (id: number | string, iducet: number | string) => {
    return axios({
        method: 'DELETE',
        url: `/DOK/${id}/ucet/${iducet}`
    });
};
export const dokumentUcetDfpPut = (id: number | string, iducet: number | string, data: IDodatekDFPUcetPut) => {
    return axios({
        method: 'PUT',
        url: `/DOK/${id}/ucet/${iducet}`,
        data: data
    }).then((resp: AxiosResponse<IZalozeniPostId>) => resp.data);
};
export const dokumentUcetDfpPost = (id: number | string, data: IDodatekDFPUcetPut) => {
    return axios({
        method: 'POST',
        url: `/DOK/${id}/ucet`,
        data: data
    }).then((resp: AxiosResponse<IZalozeniPostId>) => resp.data);
};

export interface IDodatekDVP {
    bankucet: 'NYNI' | 'PRIKAZ';
    celkcastka: number;
    celkpocupis: number;
    typplatby?: 'TUP' | 'ZAP';
    castka?: number;
    mena?: string;
    predcisli?: string;
    cislouctu?: string;
    banka?: string;
    iban?: string;
    bic?: string;
    nazprij?: string;
    adrprij1?: string;
    adrprij2?: string;
    adrprij3?: string;
    adrprij4?: string;
    bicprij?: string;
}

export const dokumentUcetDvpGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/dvp`
    }).then((resp: AxiosResponse<IDodatekDVP>) => resp.data);
};

export const dokumentUcetDvpSend = (id: number | string, data: IDodatekDVP, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/DOKdodatek/${id}/dvp`,
        data: data
    });
};

export interface IDodatekAdmin {
    idzmenadmin: number;
    datum: string;
    typzmeny: 'ANO' | 'NE' | 'PONECHAT' | 'ZMENIT' | 'ODSTRANIT';
    idmb: string;
    pjma: string;
    jmma: string;
    email: string;
    telefon: string;
    typaut: 'PXKLIC' | 'CERT';
    ceriss: string;
    cersn: string;
    nazev: string;
    admin: string;
    adma: string;
    mema: string;
    pscm: string;
    kost: string;
    isin?: string;
}

export const getRequireAdminData = (ico: number | string) => {
    return axios({
        method: 'GET',
        url: '/DOKdodatek/admin',
        params: {
            ico: ico
        }
    });
};
export const dokumentAdminGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/admin`
    }).then((resp: AxiosResponse<IDodatekAdmin>) => resp.data);
};
export const dokumentAdminPut = (id: number | string, data: IDodatekAdmin) => {
    return axios({
        method: 'PUT',
        url: `/DOKdodatek/${id}/admin`,
        data: data
    });
};

export const dodatekDluhopisGenerovatDatum = (data: {
    frekvence: EFrekvenceVyplaty;
    datemise: string;
    datsplat: string;
    pocet: number;
}) => {
    return axios({
        method: 'PUT',
        url: '/DOKdodatek/generdatdluh',
        data: data
    }).then(
        (
            resp: AxiosResponse<{
                dluhdatumy: IDodatekDluhDatum[];
            }>
        ) => resp.data
    );
};

export const updateEmitentData = (
    id: number | string,
    data: {
        idmb: string;
        nazev: string;
        dicdph: string;
        lei: string;
        adma: string;
        mema: string;
        pscm: string;
        kost: string;
        nace: string;
    }
) => {
    return axios({
        method: 'PUT',
        url: `/DOK/${id}/emitent`,
        data: data
    });
};
